enum InstanceStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNBOUND_CONTRACT = 'UNBOUND_CONTRACT',
  ACTIVE_WITH_CONSUMPTION = 'ACTIVE_WITH_CONSUMPTION',
  ACTIVE_WITHOUT_CONSUMPTION = 'ACTIVE_WITHOUT_CONSUMPTION',
  INACTIVE_WITH_CONSUMPTION = 'INACTIVE_WITH_CONSUMPTION',
  INACTIVE_WITHOUT_CONSUMPTION = 'INACTIVE_WITHOUT_CONSUMPTION',
  UNBOUND_CONTRACT_WITH_CONSUMPTION = 'UNBOUND_CONTRACT_WITH_CONSUMPTION',
  UNBOUND_CONTRACT_WITHOUT_CONSUMPTION = 'UNBOUND_CONTRACT_WITHOUT_CONSUMPTION'
}

enum InstanceStatusType {
  WITH_CONSUMPTION = 'WITH_CONSUMPTION',
  WITHOUT_CONSUMPTION = 'WITHOUT_CONSUMPTION'
}

const getInstanceUrlQueryParams = (value: string | (string | null)[]) => {
  if (value) {
    return value.toString();
  }
  return '';
}

export default {
  InstanceStatus,
  InstanceStatusType,
  getInstanceUrlQueryParams,
}
